// extracted by mini-css-extract-plugin
module.exports = {"divider":"Navigation_divider__1_eEw"};